import * as types from './types';

export const getLeads = ({ variables }) => {
  return {
    type: types.GET_LEADS,
    payload: variables,
  };
};

export const getSingleLead = (variables) => {
  return {
    type: types.GET_SINGLE_LEAD,
    payload: variables,
  };
};

export const searchLeads = ({ variables }) => {
  return {
    type: types.SEARCH_LEADS,
    payload: variables,
  };
};

export const getLeadsFilters = ({ variables } = {}) => {
  return {
    type: types.GET_LEADS_FILTERS,
    payload: variables,
  };
};

export const getLeadsFiltersInBackground = ({ variables } = {}) => {
  return {
    type: types.GET_LEADS_FILTERS_IN_BACKGROUND,
    payload: variables,
  };
};

export const updateLeadStatus = ({ variables, current }) => {
  return {
    type: types.UPDATE_LEAD_STATUS,
    payload: { variables, current },
  };
};

export const updateLeadCancel = () => {
  return {
    type: types.UPDATE_LEAD_CANCEL,
  };
};

export const deleteLeadRecord = ({ variables }) => {
  return {
    type: types.DELETE_LEAD_STATUS,
    payload: { variables },
  };
};

export const deleteLeadCancel = () => {
  return {
    type: types.DELETE_LEAD_CANCEL,
  };
};

export const updateLeadPreference = () => {
  return {
    type: types.UPDATE_LEAD_PREFERENCES,
  };
};

export const getLeadPreferences = () => {
  return {
    type: types.GET_LEAD_PREFERENCES,
  };
};

export const getOrgMembers = ({ variables }) => {
  return {
    type: types.GET_ORG_MEMBERS,
    payload: variables,
  };
};

export const getLeadAssignments = (payload) => {
  return {
    type: types.GET_LEAD_ASSIGNMENTS,
    payload,
  };
};

export const createLeadAssignment = () => {
  return {
    type: types.CREATE_LEAD_ASSIGNMENT,
  };
};

export const deleteLeadAssignment = () => {
  return {
    type: types.DELETE_LEAD_ASSIGNMENT,
  };
};

export const getLeadCustomPreferences = () => {
  return {
    type: types.GET_LEAD_CUSTOM_PREFERENCES,
  };
};
